import React, { useRef, useCallback, useState, useEffect } from 'react'
import Webcam from 'react-webcam'
import { ReactMic } from '@cleandersonlobo/react-mic'
import { uploadFile } from 'react-s3'
import { useSelector } from 'react-redux'
import './../styles.css'
import cheatingService from '../../../services/cheatingService'
import ReactCountdownClock from 'react-countdown-clock'
import { useHistory } from 'react-router-dom'

const SpyLogic = (props) => {
  const history = useHistory()
  const webcamRef = useRef(null)
  const user = useSelector((state) => state.auth.user)
  const [cnt, setCnt] = useState(1)
  const [record, setRecord] = useState(false)
  const [frst, setFrst] = useState(true)
  const [monitoringStarted, setMonitoringStarted] = useState(false)
  const [audioReady, setAudioReady] = useState(false)
  const restartRecordingAfterRef = useRef(0)

  const { examId, timeRemaining } = props
  // {
  //   examId: '123456789',
  //   timeRemaining: 0.1 * 3600
  // }

  /*
  const S3_BUCKET = ''
  const REGION = ''
  const ACCESS_KEY = ''
  const SECRET_ACCESS_KEY = ''
  */
  const S3_BUCKET = ''
  const REGION = ''
  const ACCESS_KEY = ''
  const SECRET_ACCESS_KEY = ''

  const config = {
    bucketName: S3_BUCKET,
    region: REGION,
    dirName: user.name + ':' + user._id,
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY
  }

  const handleUpload = async (file) => {
    uploadFile(file, config)
      .then((data) => console.log(data))
      .catch((err) => console.error(err))
  }

  const startRecording = useCallback(() => {
    setRecord(true)
  }, [])

  const stopRecording = useCallback(() => {
    setRecord(false)
  }, [])

  const handleStartMonitoring = useCallback(() => {
    if (monitoringStarted) return
    setMonitoringStarted(true)
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setAudioReady(true)
      return
    }
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        stream.getTracks().forEach((t) => t.stop())
        setTimeout(() => {
          setRecord(true)
          setTimeout(() => setAudioReady(true), 2500)
        }, 300)
      })
      .catch(() => setAudioReady(true))
  }, [monitoringStarted])

  const eventHandler = () => {
    document.title = document.hidden
      ? window.close()
      : "DON'T go away"
  }

  useEffect(() => {
    document.addEventListener('visibilitychange', eventHandler)
    try {
      cheatingService.clear()
    } catch {
      console.log('no pre counter fount')
    }
  }, [])

  useEffect(() => {
    return () => {
      document.removeEventListener('visibilitychange', eventHandler)
      stopRecording()
      history.goBack()
    }
  }, [history])

  const onStop = async (recordedBlob) => {
    console.log('recordedBlob is: ', recordedBlob)
    const blob = await fetch(recordedBlob.blobURL).then((res) => res.blob())
    blob.name = 'recording.mp3'
    handleUpload(blob)
  }

  const capture = useCallback(async () => {
    if (!webcamRef.current) return
    if (frst) {
      setFrst(false)
      return
    }
    if (cnt === 1 && audioReady && Date.now() >= restartRecordingAfterRef.current) {
      startRecording()
    }
    setCnt((c) => c + 1)
    const imageSrc = webcamRef.current.getScreenshot()
    if (!imageSrc) return
    const blob = await fetch(imageSrc).then((res) => res.blob())
    blob.name = cnt.toString() + '.jpeg'
    if (cnt === 7) {
      setCnt(1)
      stopRecording()
      restartRecordingAfterRef.current = Date.now() + 2000
    }
    handleUpload(blob)
    cheatingService.batchInc(examId)
  }, [cnt, frst, audioReady, startRecording, stopRecording, examId])

  //useEffect(setInterval(() => {capture()}, 2000), [webcamRef, cnt])

  useEffect(() => {
    if (!audioReady) return
    const intervalId = setInterval(capture, 1500)
    return () => clearInterval(intervalId)
  }, [audioReady, capture])

  return (
    <div className="container">
      {!monitoringStarted && (
        <div style={{ marginBottom: 16, textAlign: 'center' }}>
          <button
            type="button"
            onClick={handleStartMonitoring}
            style={{
              padding: '12px 24px',
              fontSize: 16,
              cursor: 'pointer',
              backgroundColor: '#1890ff',
              color: '#fff',
              border: 'none',
              borderRadius: 4
            }}
          >
            Start camera & microphone
          </button>
          <p style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
            Allow microphone when prompted so recording can start.
          </p>
        </div>
      )}
      <Webcam
        audio={false}
        width={240}
        height={240}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          width: 240,
          height: 240,
          facingMode: 'user'
        }}
      />
      <ReactMic
        record={record}
        className="sound-wave"
        mimeType="audio/mp3"
        onStop={onStop}
        echoCancellation={true}
        autoGainControl={true}
        noiseSuppression={true}
      />
      <ReactCountdownClock
        seconds={timeRemaining}
        color="#000"
        alpha={0.9}
        size={240}
        onComplete={() => {
          stopRecording()
          cheatingService.clear()
          document.removeEventListener('visibilitychange', eventHandler)
          window.close()
        }}
      />
    </div>
  )
}

export default SpyLogic
